import {Base} from '../../common/model/base.model';

export class GeoProvincia extends Base {

  constructor(protected id: number,
              public denominazione: string,
              public sigla: string
  ) {
    super(id);
  }

  public getLabel() {
    return ' (' + this.sigla + ')';
  }

}
